export default __webpack_public_path__ + "static/media/construction.373a29f8.png";